import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useCreditPack(loanId: string, enabled = false) {
  return useQuery({
    queryKey: ['loans', loanId, 'credit-pack'],
    queryFn: () => api.get(`/loans/${loanId}/credit-pack`).then(r => r.data),
    enabled: !!loanId && enabled,
  });
}
